// store/neumaticos/index.js

//#region storage
const STORAGE_PRODUCTS = "neumaticos_products";
const STORAGE_REMOVED_PRODUCTS = "neumaticos_removed_products";
const STORAGE_SHOPPING_STEP = "neumaticos_shopping_step";
const STORAGE_ULTIMO_PASO = "neumaticos_ultimo_paso";
const STORAGE_PASOAPASO = "neumaticos_pasoapaso";
const STORAGE_ACCEPT_TERMS = "neumaticos_accept_terms";
const STORAGE_ACCEPT_POLITICA = "neumaticos_accept_politica";
const STORAGE_LOCAL_PIVOTE = "neumaticos_local_pivote";
const STORAGE_FULL_CERCANO = "neumaticos_full_cercano";
const STORAGE_LOCAL_SELECCIONADO = "neumaticos_local_seleccionado";
const STORAGE_LOCAL_CAMBIO = "neumaticos_local_cambio";
const STORAGE_UBICATION = "neumaticos_ubication";
const STORAGE_UBICATION_CONFIRMED = "neumaticos_ubication_confirmed";
const STORAGE_BATTERY_INSTALL_TYPE = "neumaticos_battery_install_type";
const STORAGE_SERVICES = "neumaticos_services";
const STORAGE_CALENDAR = "neumaticos_calendar";
const STORAGE_ADDRESSES = "neumaticos_addresses";
const STORAGE_PERSONAL_INFORMATION = "neumaticos_personal_information";
const STORAGE_PAYMENT = "neumaticos_payment";
const STORAGE_GIFTCARD = "neumaticos_giftcard";
const STORAGE_GIFTS = "neumaticos_gifts";
const STORAGE_REGALO_RULETA = "neumaticos_regalo_ruleta";
const STORAGE_CART_TIMESTAMP = "neumaticos_cart_timestamp";
const STORAGE_TRANSACTION_UUID = "neumaticos_transaction_uuid";
const STORAGE_CARRITO_CODIGO = "neumaticos_carrito_codigo";
//#endregion storage

//#region state
const state = function () {
  return {
    products: [],
    removedProducts: [],
    shoppingStep: 0,
    ultimo_paso: 0,
    region: null,
    commune: null,
    personalInfoSaved: false,
    pasoapaso: 0,
    acceptTerms: false,
    acceptPolitica: false,
    localpivote: {},
    fullcercano: {},
    localSeleccionado: null,
    local_cambio: false,
    ubication: {
      isLoading: false,
      latitude: null,
      longitude: null,
      address: "",
      region: "",
      commune: "",
    },
    ubication_confirmed: {
      isLoading: false,
      latitude: null,
      longitude: null,
      address: "",
      region: "",
      commune: "",
    },
    batteryInstallType: "",
    isValidCarplate: "",
    services: [],
    calendar: {
      checkStoreAvailability: false,
      scheduleType: 1,
      date: new Date().toISOString().slice(0, 10),
      time: null,
      totalTime: 0,
      tempario: "",
    },
    addresses: {
      showAddressOptions: false,
      showLeaveAddress: false,
      address: {
        region: null,
        commune: null,
        address: "",
        details: "",
        comments: "",
        latitude: null,
        longitude: null,
      },
      leaveAddress: {
        region: null,
        commune: null,
        address: "",
        details: "",
        comments: "",
        latitude: null,
        longitude: null,
      },
    },
    personalInformation: {
      rut: "",
      name: "",
      lastName: "",
      surName: "",
      email: "",
      phone: "",
      carplate: "",
      patente_pais: "",
    },
    payment: {
      paymentId: "",
      paymentMethod: "",
    },
    giftcardInput: "",
    isGiftcardInfoLoading: false,
    giftcard: {
      itWasSend: false,
      isValid: false,
      code: "",
      uuid: "",
      descriptionCode: "",
    },

    history: [],
    cartTimestamp: null,
    transaction_uuid: null,
    carrito_codigo: null,

    gifts: [],
    regalo_ruleta: [],
    /*
      "code": "",
      "description": "",
      "unitPrice": 0,
      "quantity": 1,
      "photo": ""
    */
  };

};
//#endregion state

//#region mutations
let expirationTimer;

const mutations = {
  //#region GETTERS
  getProducts: function (state) {
    const products = localStorage.getItem(STORAGE_PRODUCTS) ? JSON.parse(localStorage.getItem(STORAGE_PRODUCTS)) : [];
    state.products = products;
  },

  getRemovedProducts: function (state) {
    const removedProducts = localStorage.getItem(STORAGE_REMOVED_PRODUCTS) ? JSON.parse(localStorage.getItem(STORAGE_REMOVED_PRODUCTS)) : [];
    state.removedProducts = removedProducts;
  },

  getShoppingStep: function (state) {
    const shoppingStep = localStorage.getItem(STORAGE_SHOPPING_STEP) ? parseInt(localStorage.getItem(STORAGE_SHOPPING_STEP)) : 0;
    state.shoppingStep = shoppingStep;
  },

  getUltimo_paso: function (state) {
    const ultimo_paso = localStorage.getItem(STORAGE_ULTIMO_PASO) ? parseInt(localStorage.getItem(STORAGE_ULTIMO_PASO)) : 0;
    state.ultimo_paso = ultimo_paso;
  },

  getPasoAPaso: function (state) {
    const pasoapaso = localStorage.getItem(STORAGE_PASOAPASO);
    state.pasoapaso = pasoapaso;
  },

  getAcceptTerms: function (state) {
    const acceptTerms = localStorage.getItem(STORAGE_ACCEPT_TERMS);
    state.acceptTerms = acceptTerms === "true" ? true : false;
  },

  getAcceptPolitica: function (state) {
    const acceptPolitica = localStorage.getItem(STORAGE_ACCEPT_POLITICA);
    state.acceptPolitica = acceptPolitica === "true" ? true : false;
  },

  getLocalPivote: function (state) {
    try {
      const localItem = localStorage.getItem(STORAGE_LOCAL_PIVOTE);

      if (localItem && localItem !== "undefined") {
        try {
          const localpivote = JSON.parse(localItem);
          state.localpivote = localpivote;
          //console.log("[STORE NEUMATICOS] state.localpivote: ", state.localpivote?.alias);
        } catch (parseError) {
          //console.error("Error al parsear localpivote:", parseError);
          state.localpivote = {};
          //console.log("[STORE NEUMATICOS] state.localpivote: ", state.localpivote?.alias);
        }
      } else {
        //console.log("[STORE NEUMATICOS] state.localpivote: ", state.localpivote?.alias);
        state.localpivote = {};
      }
    } catch (error) {
      //console.error("Error al acceder a localStorage:", error);
      state.localpivote = {};
      //console.log("[STORE NEUMATICOS] state.localpivote: ", state.localpivote?.alias);
    }
  },

  getFullcercano: function (state) {
    const fullcercano = localStorage.getItem(STORAGE_FULL_CERCANO) ? JSON.parse(localStorage.getItem(STORAGE_FULL_CERCANO)) : {};
    state.fullcercano = fullcercano;
  },

  getlocalSeleccionado: function (state) {
    const localSeleccionado = localStorage.getItem(STORAGE_LOCAL_SELECCIONADO) ? JSON.parse(localStorage.getItem(STORAGE_LOCAL_SELECCIONADO)) : null;
    state.localSeleccionado = localSeleccionado;
  },

  getLocal_cambio: function (state) {
    const local_cambio = localStorage.getItem(STORAGE_LOCAL_CAMBIO) ? JSON.parse(localStorage.getItem(STORAGE_LOCAL_CAMBIO)) : false;
    state.local_cambio = local_cambio;
  },

  getUbication: function (state) {
    const ubication = JSON.parse(localStorage.getItem(STORAGE_UBICATION))
      ? JSON.parse(localStorage.getItem(STORAGE_UBICATION))
      : {
          latitude: null,
          longitude: null,
          address: "",
          region: "",
          commune: "",
          isLoading: false,
        };
    state.ubication = ubication;
  },

  getUbication_confirmed: function (state) {
    const ubicacion = JSON.parse(localStorage.getItem(STORAGE_UBICATION_CONFIRMED))
      ? JSON.parse(localStorage.getItem(STORAGE_UBICATION_CONFIRMED))
      : {
          latitude: null,
          longitude: null,
          address: "",
          region: "",
          commune: "",
          isLoading: false,
        };
    state.ubication_confirmed = ubicacion;
  },

  getBatteryInstallType: function (state) {
    const batteryInstallType = localStorage.getItem(STORAGE_BATTERY_INSTALL_TYPE) ? localStorage.getItem(STORAGE_BATTERY_INSTALL_TYPE) : null;
    state.batteryInstallType = batteryInstallType;
  },

  getServicesStore: function (state) {
    const services = JSON.parse(localStorage.getItem(STORAGE_SERVICES)) ? JSON.parse(localStorage.getItem(STORAGE_SERVICES)) : [];
    state.services = services;
  },

  getCalendar: function (state, scheduleType = 1) {
    const calendar = JSON.parse(localStorage.getItem(STORAGE_CALENDAR))
      ? JSON.parse(localStorage.getItem(STORAGE_CALENDAR))
      : {
          checkStoreAvailability: false,
          scheduleType: parseInt(scheduleType),
          date: new Date().toISOString().slice(0, 10),
          time: null,
          totalTime: 0,
          tempario: "",
        };
    state.calendar = calendar;
  },

  getAddresses: function (state) {
    const resetAddress = {
      showAddressOptions: false,
      showLeaveAddress: false,
      address: { region: "", commune: "", address: "", details: "", comments: "" },
      leaveAddress: { region: "", commune: "", address: "", details: "", comments: "" },
    };
    const addresses = JSON.parse(localStorage.getItem(STORAGE_ADDRESSES)) ? JSON.parse(localStorage.getItem(STORAGE_ADDRESSES)) : resetAddress;
    state.addresses = addresses;
  },

  getPersonalInformation: function (state) {
    const personalInformation = JSON.parse(localStorage.getItem(STORAGE_PERSONAL_INFORMATION))
      ? JSON.parse(localStorage.getItem(STORAGE_PERSONAL_INFORMATION))
      : { name: "", lastName: "", surName: "", email: "", phone: "", rut: "", carplate: "" };

    state.personalInformation = personalInformation;
  },

  getPayment: function (state) {
    const payment = JSON.parse(localStorage.getItem(STORAGE_PAYMENT)) ? JSON.parse(localStorage.getItem(STORAGE_PAYMENT)) : { paymentId: "", paymentMethod: "" };
    state.payment = payment;
  },

  getGiftcard: function (state) {
    const giftcard = JSON.parse(localStorage.getItem(STORAGE_GIFTCARD))
      ? JSON.parse(localStorage.getItem(STORAGE_GIFTCARD))
      : {
          itWasSend: false,
          isValid: false,
          code: "",
          uuid: "",
          descriptionCode: "",
        };
    state.giftcard = giftcard;
  },

  getGifts: function (state) {
    const gifts = JSON.parse(localStorage.getItem(STORAGE_GIFTS)) ? JSON.parse(localStorage.getItem(STORAGE_GIFTS)) : [];
    state.gifts = gifts;
  },

  getRegaloRuleta: function (state) {
    const regalo_ruleta = JSON.parse(localStorage.getItem(STORAGE_REGALO_RULETA)) ? JSON.parse(localStorage.getItem(STORAGE_REGALO_RULETA)) : [];
    state.regalo_ruleta = regalo_ruleta;
  },

  getCartTimestamp: function (state) {
    const cartTimestamp = localStorage.getItem(STORAGE_CART_TIMESTAMP) ? parseInt(localStorage.getItem(STORAGE_CART_TIMESTAMP)) : null;
    state.cartTimestamp = cartTimestamp;
  },

  gettransaction_uuid: function (state) {
    const transaction_uuid = localStorage.getItem(STORAGE_TRANSACTION_UUID) || null;
    state.transaction_uuid = transaction_uuid;
  },

  getCarritoCodigo: function (state) {
    const carrito_codigo = localStorage.getItem(STORAGE_CARRITO_CODIGO) || null;
    state.carrito_codigo = carrito_codigo;
  },

  getRegion: function (state) {
    const measure = useCookie("measure");
    const region = measure.value && measure.value.region ? measure.value.region : null;
    state.region = region;
  },

  getCommune: function (state) {
    const measure = useCookie("measure");
    const commune = measure.value && measure.value.commune ? measure.value.commune : null;
    state.commune = commune;
  },

  getaAddressWasChanged: function (state) {
    const addressWasChanged = localStorage.getItem("addressWasChanged") ? JSON.parse(localStorage.getItem("addressWasChanged")) : false;
    state.addressWasChanged = addressWasChanged;
  },
  //#endregion GETTERS

  //#region SETTERS
  setProducts: function (state, products) {
    state.products = products;
  },

  setPersonalInfoSaved: function (state, saved) {
    state.personalInfoSaved = saved;
  },

  setPasoAPaso: function (state, pasoapaso) {
    localStorage.setItem(STORAGE_PASOAPASO, pasoapaso);
    state.pasoapaso = pasoapaso;
  },

  setAcceptTerms: function (state, acceptTerms) {
    localStorage.setItem(STORAGE_ACCEPT_TERMS, acceptTerms);
    state.acceptTerms = acceptTerms;
  },

  setAcceptPolitica: function (state, acceptPolitica) {
    localStorage.setItem(STORAGE_ACCEPT_POLITICA, acceptPolitica);
    state.acceptPolitica = acceptPolitica;
  },

  setLocalPivote: function (state, localpivote) {
    localStorage.setItem(STORAGE_LOCAL_PIVOTE, JSON.stringify(localpivote));
    state.localpivote = localpivote;
  },

  setFullcercano: function (state, fullcercano) {
    localStorage.setItem(STORAGE_FULL_CERCANO, JSON.stringify(fullcercano));
    state.fullcercano = fullcercano;
  },

  setlocalSeleccionado: function (state, local) {
    state.localSeleccionado = local || null;
    localStorage.setItem(STORAGE_LOCAL_SELECCIONADO, JSON.stringify(local));
  },

  setLocal_cambio: function (state, local_cambio) {
    localStorage.setItem(STORAGE_LOCAL_CAMBIO, JSON.stringify(local_cambio));
    state.local_cambio = local_cambio;
  },

  setUbication: function (state, ubication) {
    localStorage.setItem(STORAGE_UBICATION, JSON.stringify(ubication));
    state.ubication = ubication;
  },

  setUbicationAddress: function (state, address) {
    const ubication = JSON.parse(localStorage.getItem(STORAGE_UBICATION))
      ? JSON.parse(localStorage.getItem(STORAGE_UBICATION))
      : {
          latitude: null,
          longitude: null,
          address: "",
          region: "",
          commune: "",
          isLoading: false,
        };
    ubication.address = address;
    localStorage.setItem(STORAGE_UBICATION, JSON.stringify(ubication));
    state.ubication = ubication;
  },

  setUbication_confirmed: function (state, ubication) {
    localStorage.setItem(STORAGE_UBICATION_CONFIRMED, JSON.stringify(ubication));
    state.ubication_confirmed = ubication;
  },

  setBatteryInstallType: function (state, batteryInstallType) {
    localStorage.setItem(STORAGE_BATTERY_INSTALL_TYPE, batteryInstallType);
    state.batteryInstallType = batteryInstallType;
  },

  setShoppingStep: function (state, step) {
    localStorage.setItem(STORAGE_SHOPPING_STEP, step);
    state.shoppingStep = step;
  },

  setUltimo_paso: function (state, ultimo_paso) {
    localStorage.setItem(STORAGE_ULTIMO_PASO, ultimo_paso);
    state.ultimo_paso = ultimo_paso;
  },

  setRegion: function (state, region) {
    const measure = useCookie("measure");
    if (measure.value) {
      measure.value.region = region;
    } else {
      measure.value = {
        region: region,
      };
    }
    state.region = region;
  },

  setCommune: function (state, commune) {
    const measure = useCookie("measure");
    measure.value.commune = commune;
    state.commune = commune;
  },

  setCheckStoreAvailability: function (state, { checkStoreAvailability, scheduleType = 1 }) {
    const calendar = JSON.parse(localStorage.getItem(STORAGE_CALENDAR))
      ? JSON.parse(localStorage.getItem(STORAGE_CALENDAR))
      : {
          checkStoreAvailability: false,
          scheduleType: parseInt(scheduleType),
          date: new Date().toISOString().slice(0, 10),
          time: null,
          totalTime: 0,
          tempario: "",
        };
    calendar.checkStoreAvailability = checkStoreAvailability;
    localStorage.setItem(STORAGE_CALENDAR, JSON.stringify(calendar));
    state.calendar = calendar;
  },

  setScheduleType: function (state, scheduleType = 1) {
    const calendar = JSON.parse(localStorage.getItem(STORAGE_CALENDAR))
      ? JSON.parse(localStorage.getItem(STORAGE_CALENDAR))
      : {
          checkStoreAvailability: false,
          scheduleType: parseInt(scheduleType),
          date: new Date().toISOString().slice(0, 10),
          time: null,
          totalTime: 0,
          tempario: "",
        };
    calendar.scheduleType = parseInt(scheduleType);
    localStorage.setItem(STORAGE_CALENDAR, JSON.stringify(calendar));
    state.calendar = calendar;
  },

  setDate: function (state, { date, scheduleType = 1 }) {
    const calendar = JSON.parse(localStorage.getItem(STORAGE_CALENDAR))
      ? JSON.parse(localStorage.getItem(STORAGE_CALENDAR))
      : {
          checkStoreAvailability: false,
          scheduleType: parseInt(scheduleType),
          date: new Date().toISOString().slice(0, 10),
          time: null,
          totalTime: 0,
          tempario: "",
        };
    calendar.date = date;
    localStorage.setItem(STORAGE_CALENDAR, JSON.stringify(calendar));
    state.calendar = calendar;
  },

  setTime: function (state, { time, scheduleType = 1 }) {
    const calendar = JSON.parse(localStorage.getItem(STORAGE_CALENDAR))
      ? JSON.parse(localStorage.getItem(STORAGE_CALENDAR))
      : {
          checkStoreAvailability: false,
          scheduleType: parseInt(scheduleType),
          date: new Date().toISOString().slice(0, 10),
          time: null,
          totalTime: 0,
          tempario: "",
        };
    calendar.time = time;
    localStorage.setItem(STORAGE_CALENDAR, JSON.stringify(calendar));
    state.calendar = calendar;
  },

  setTotalTime: function (state, { totalTime, scheduleType = 1 }) {
    const calendar = JSON.parse(localStorage.getItem(STORAGE_CALENDAR))
      ? JSON.parse(localStorage.getItem(STORAGE_CALENDAR))
      : {
          checkStoreAvailability: false,
          scheduleType: parseInt(scheduleType),
          date: new Date().toISOString().slice(0, 10),
          time: null,
          totalTime: 0,
          tempario: "",
        };
    calendar.totalTime = totalTime;
    localStorage.setItem(STORAGE_CALENDAR, JSON.stringify(calendar));
    state.calendar = calendar;
  },

  setTempario: function (state, { tempario, scheduleType = 1 }) {
    const calendar = JSON.parse(localStorage.getItem(STORAGE_CALENDAR))
      ? JSON.parse(localStorage.getItem(STORAGE_CALENDAR))
      : {
          checkStoreAvailability: false,
          scheduleType: parseInt(scheduleType),
          date: new Date().toISOString().slice(0, 10),
          time: null,
          totalTime: 0,
          tempario: "",
        };
    calendar.tempario = tempario;
    localStorage.setItem(STORAGE_CALENDAR, JSON.stringify(calendar));
    state.calendar = calendar;
  },

  setCalendarToDefault: function (state, scheduleType = 1) {
    const calendar = {
      checkStoreAvailability: false,
      scheduleType: parseInt(scheduleType),
      date: new Date().toISOString().slice(0, 10),
      time: null,
      totalTime: 0,
      tempario: "",
    };
    localStorage.setItem(STORAGE_CALENDAR, JSON.stringify(calendar));
    state.calendar = calendar;
  },

  setShowAddressOptions: function (state, showAddressOptions) {
    const resetAddress = {
      showAddressOptions: false,
      showLeaveAddress: false,
      address: { region: "", commune: "", address: "", details: "", comments: "" },
      leaveAddress: { region: "", commune: "", address: "", details: "", comments: "" },
    };
    const addresses = JSON.parse(localStorage.getItem(STORAGE_ADDRESSES)) ? JSON.parse(localStorage.getItem(STORAGE_ADDRESSES)) : resetAddress;
    addresses.showAddressOptions = showAddressOptions;
    localStorage.setItem(STORAGE_ADDRESSES, JSON.stringify(addresses));
    state.addresses = addresses;
  },

  setShowLeaveAddress: function (state, showLeaveAddress) {
    const resetAddress = {
      showAddressOptions: false,
      showLeaveAddress: false,
      address: { region: "", commune: "", address: "", details: "", comments: "" },
      leaveAddress: { region: "", commune: "", address: "", details: "", comments: "" },
    };
    const addresses = JSON.parse(localStorage.getItem(STORAGE_ADDRESSES)) ? JSON.parse(localStorage.getItem(STORAGE_ADDRESSES)) : resetAddress;
    addresses.showLeaveAddress = showLeaveAddress;
    localStorage.setItem(STORAGE_ADDRESSES, JSON.stringify(addresses));
    state.addresses = addresses;
  },

  setAddress: function (state, address) {
    const resetAddress = {
      showAddressOptions: false,
      showLeaveAddress: false,
      address: { region: "", commune: "", address: "", details: "", comments: "" },
      leaveAddress: { region: "", commune: "", address: "", details: "", comments: "" },
    };
    const addresses = JSON.parse(localStorage.getItem(STORAGE_ADDRESSES)) ? JSON.parse(localStorage.getItem(STORAGE_ADDRESSES)) : resetAddress;
    addresses.address = address;
    localStorage.setItem(STORAGE_ADDRESSES, JSON.stringify(addresses));
    state.addresses = addresses;
  },

  setLeaveAddress: function (state, leaveAddress) {
    const resetAddress = {
      showAddressOptions: false,
      showLeaveAddress: false,
      address: { region: "", commune: "", address: "", details: "", comments: "" },
      leaveAddress: { region: "", commune: "", address: "", details: "", comments: "" },
    };
    const addresses = JSON.parse(localStorage.getItem(STORAGE_ADDRESSES)) ? JSON.parse(localStorage.getItem(STORAGE_ADDRESSES)) : resetAddress;
    addresses.leaveAddress = leaveAddress;
    localStorage.setItem(STORAGE_ADDRESSES, JSON.stringify(addresses));
    state.addresses = addresses;
  },

  setAddressRegion: function (state, { region, type }) {
    const resetAddress = {
      showAddressOptions: false,
      showLeaveAddress: false,
      address: { region: "", commune: "", address: "", details: "", comments: "" },
      leaveAddress: { region: "", commune: "", address: "", details: "", comments: "" },
    };
    const addresses = JSON.parse(localStorage.getItem(STORAGE_ADDRESSES)) ? JSON.parse(localStorage.getItem(STORAGE_ADDRESSES)) : resetAddress;
    if (type == "address") {
      addresses.address.region = region;
    } else {
      addresses.leaveAddress.region = region;
    }
    localStorage.setItem(STORAGE_ADDRESSES, JSON.stringify(addresses));
    state.addresses = addresses;
  },

  setAddressCommune: function (state, { commune, type }) {
    const resetAddress = {
      showAddressOptions: false,
      showLeaveAddress: false,
      address: { region: "", commune: "", address: "", details: "", comments: "" },
      leaveAddress: { region: "", commune: "", address: "", details: "", comments: "" },
    };
    const addresses = JSON.parse(localStorage.getItem(STORAGE_ADDRESSES)) ? JSON.parse(localStorage.getItem(STORAGE_ADDRESSES)) : resetAddress;
    if (type == "address") {
      addresses.address.commune = commune;
    } else {
      addresses.leaveAddress.commune = commune;
    }
    localStorage.setItem(STORAGE_ADDRESSES, JSON.stringify(addresses));
    state.addresses = addresses;
  },

  setAddressAddress: function (state, { address, type }) {
    const resetAddress = {
      showAddressOptions: false,
      showLeaveAddress: false,
      address: { region: "", commune: "", address: "", details: "", comments: "" },
      leaveAddress: { region: "", commune: "", address: "", details: "", comments: "" },
    };
    const addresses = JSON.parse(localStorage.getItem(STORAGE_ADDRESSES)) ? JSON.parse(localStorage.getItem(STORAGE_ADDRESSES)) : resetAddress;
    if (type == "address") {
      addresses.address.address = address;
    } else {
      addresses.leaveAddress.address = address;
    }
    localStorage.setItem(STORAGE_ADDRESSES, JSON.stringify(addresses));
    state.addresses = addresses;
  },

  setAddressDetails: function (state, { details, type }) {
    const resetAddress = {
      showAddressOptions: false,
      showLeaveAddress: false,
      address: { region: "", commune: "", address: "", details: "", comments: "" },
      leaveAddress: { region: "", commune: "", address: "", details: "", comments: "" },
    };
    const addresses = JSON.parse(localStorage.getItem(STORAGE_ADDRESSES)) ? JSON.parse(localStorage.getItem(STORAGE_ADDRESSES)) : resetAddress;
    if (type == "address") {
      addresses.address.details = details;
    } else {
      addresses.leaveAddress.details = details;
    }
    localStorage.setItem(STORAGE_ADDRESSES, JSON.stringify(addresses));
    state.addresses = addresses;
  },

  setAddressLatitudeAndLongitude: function (state, { latitude, longitude, type }) {
    const resetAddress = {
      showAddressOptions: false,
      showLeaveAddress: false,
      address: { region: "", commune: "", address: "", details: "", comments: "" },
      leaveAddress: { region: "", commune: "", address: "", details: "", comments: "" },
    };
    const addresses = JSON.parse(localStorage.getItem(STORAGE_ADDRESSES)) ? JSON.parse(localStorage.getItem(STORAGE_ADDRESSES)) : resetAddress;
    if (type == "address") {
      addresses.address.latitude = latitude;
      addresses.address.longitude = longitude;
    } else {
      addresses.leaveAddress.latitude = latitude;
      addresses.leaveAddress.longitude = longitude;
    }
    localStorage.setItem(STORAGE_ADDRESSES, JSON.stringify(addresses));
    state.addresses = addresses;
  },

  setAddressComments: function (state, { comments, type }) {
    const resetAddress = {
      showAddressOptions: false,
      showLeaveAddress: false,
      address: { region: "", commune: "", address: "", details: "", comments: "" },
      leaveAddress: { region: "", commune: "", address: "", details: "", comments: "" },
    };
    const addresses = JSON.parse(localStorage.getItem(STORAGE_ADDRESSES)) ? JSON.parse(localStorage.getItem(STORAGE_ADDRESSES)) : resetAddress;
    if (type == "address") {
      addresses.address.comments = comments;
    } else {
      addresses.leaveAddress.comments = comments;
    }
    localStorage.setItem(STORAGE_ADDRESSES, JSON.stringify(addresses));
    state.addresses = addresses;
  },

  setPersonalInformation: function (state, personalInformation) {
    localStorage.setItem(STORAGE_PERSONAL_INFORMATION, JSON.stringify(personalInformation));
    state.personalInformation = personalInformation;
  },

  setPayment: function (state, payment) {
    localStorage.setItem(STORAGE_PAYMENT, JSON.stringify(payment));
    state.payment = payment;
  },

  setGiftcard: function (state, giftcard) {
    localStorage.setItem(STORAGE_GIFTCARD, JSON.stringify(giftcard));
    state.giftcard = giftcard;
  },

  setGifts: function (state, gifts) {
    console.log("seteando gifts: ",gifts);
    localStorage.setItem(STORAGE_GIFTS, JSON.stringify(gifts));
    state.gifts = gifts;
  },

  setRegaloRuleta: function (state, regalo) {
    console.log("seteando regalo ruleta, regalo: ", regalo);
    localStorage.setItem(STORAGE_REGALO_RULETA, JSON.stringify(regalo));
    state.regalo_ruleta = regalo;
  },

  setCartTimestamp: function (state, cartTimestamp) {
    localStorage.setItem(STORAGE_CART_TIMESTAMP, cartTimestamp);
    state.cartTimestamp = cartTimestamp;
  },

  settransaction_uuid: function (state, transaction_uuid) {
    localStorage.setItem(STORAGE_TRANSACTION_UUID, transaction_uuid);
    state.transaction_uuid = transaction_uuid;
  },

  setCarritoCodigo: function (state, codigo) {
    if (codigo) {
      localStorage.setItem(STORAGE_CARRITO_CODIGO, codigo);
    } else {
      localStorage.removeItem(STORAGE_CARRITO_CODIGO);
    }
    state.carrito_codigo = codigo || null;
  },

  setgiftcardInput: function (state, value) {
    //console.log("setgiftcardInput, value: ", value);
    state.giftcardInput = value;
  },

  set_giftcardLoader: function (state, value) {
    state.isGiftcardInfoLoading = value;
  },

  SET_IS_VALID_CARPLATE: function (state, isValid) {
    state.isValidCarplate = isValid;
  },
  //#endregion SETTERS

  //#region OPERACIONES (add, remove, update)
  updateProductPrice: function (state, { codigo, precio_venta_web, markup }) {
    const products = localStorage.getItem(STORAGE_PRODUCTS) ? JSON.parse(localStorage.getItem(STORAGE_PRODUCTS)) : [];
    const existingProductIndex = products.findIndex((item) => item.product.codigo === codigo);
    if (existingProductIndex !== -1) {
      products[existingProductIndex].product.precio_venta_web = precio_venta_web;
      products[existingProductIndex].product.markup = markup;
    } else {
      //console.log("updateProductPrice - producto no encontrado: ", codigo);
    }
    localStorage.setItem(STORAGE_PRODUCTS, JSON.stringify(products));
    state.products = products;
  },

  addProducts: function (state, { selectedProduct, selectQuantity }) {
    const products = localStorage.getItem(STORAGE_PRODUCTS) ? JSON.parse(localStorage.getItem(STORAGE_PRODUCTS)) : [];
    const carrito_estaba_vacio = products.length === 0;
    const existingProductIndex = products.findIndex((item) => item.product.codigo === selectedProduct.codigo);
    const totalUnitsInCart = products.reduce((total, item) => total + item.quantity, 0);
    if (existingProductIndex !== -1) {
      if (totalUnitsInCart + selectQuantity <= 3 || products.length === 1) {
        products[existingProductIndex].quantity = products.length == 1 && totalUnitsInCart + selectQuantity > 5 ? 5 : products[existingProductIndex].quantity + selectQuantity;
      } else {
        products.forEach((product) => {
          product.quantity = 2;
        });
      }
    } else {
      products.push({
        product: selectedProduct,
        quantity: selectQuantity,
      });
      if (products.length == 1) {
        products.forEach((product) => {
          product.quantity = totalUnitsInCart + selectQuantity > 5 ? 5 : totalUnitsInCart + selectQuantity;
        });
      } else if (totalUnitsInCart + selectQuantity > 3 && products.length > 1) {
        products.forEach((product) => {
          product.quantity = 2;
        });
      }
    }
    localStorage.setItem(STORAGE_PRODUCTS, JSON.stringify(products));
    if (carrito_estaba_vacio) {
      mutations.setCartTimestamp(state, Date.now().toString());
      mutations.startExpirationTimer(state);
      localStorage.removeItem(STORAGE_CARRITO_CODIGO);
      state.carrito_codigo = null;
    }
    state.products = products;
  },

  addRemovedProducts: function (state, product) {
    const removedProducts = localStorage.getItem(STORAGE_REMOVED_PRODUCTS) ? JSON.parse(localStorage.getItem(STORAGE_REMOVED_PRODUCTS)) : [];
    removedProducts.push(product);
    localStorage.setItem(STORAGE_REMOVED_PRODUCTS, JSON.stringify(removedProducts));
    state.removedProducts = removedProducts;
  },

  addService: function (state, service) {
    const services = JSON.parse(localStorage.getItem(STORAGE_SERVICES)) ? JSON.parse(localStorage.getItem(STORAGE_SERVICES)) : [];
    const existingServiceIndex = services.findIndex((item) => item.codigo === service.codigo);
    if (existingServiceIndex === -1) {
      services.push(service);
    } else {
      services[existingServiceIndex] = service;
    }
    localStorage.setItem(STORAGE_SERVICES, JSON.stringify(services));
    state.services = services;
  },

  removeProduct: function (state, product) {
    const products = localStorage.getItem(STORAGE_PRODUCTS) ? JSON.parse(localStorage.getItem(STORAGE_PRODUCTS)) : [];
    const existingProductIndex = products.findIndex((item) => item.product.codigo === product.codigo);
    if (existingProductIndex !== -1) {
      products.splice(existingProductIndex, 1);
    }
    localStorage.setItem(STORAGE_PRODUCTS, JSON.stringify(products));
    state.products = products;
  },

  removeProductByCode: function (state, code) {
    const products = localStorage.getItem(STORAGE_PRODUCTS) ? JSON.parse(localStorage.getItem(STORAGE_PRODUCTS)) : [];
    const existingProductIndex = products.findIndex((item) => item.product.codigo === code);
    if (existingProductIndex !== -1) {
      mutations.addRemovedProducts(state, products[existingProductIndex]);
      products.splice(existingProductIndex, 1);
    }
    localStorage.setItem(STORAGE_PRODUCTS, JSON.stringify(products));
    state.products = products;
  },

  removeService: function (state, service) {
    const services = JSON.parse(localStorage.getItem(STORAGE_SERVICES)) ? JSON.parse(localStorage.getItem(STORAGE_SERVICES)) : [];
    const existingServiceIndex = services.findIndex((item) => item.codigo === service.codigo);
    if (existingServiceIndex !== -1) {
      services.splice(existingServiceIndex, 1);
    }
    localStorage.setItem(STORAGE_SERVICES, JSON.stringify(services));
    state.services = services;
  },

  removelocalSeleccionado: function (state) {
    localStorage.removeItem(STORAGE_LOCAL_SELECCIONADO);
    state.localSeleccionado = null;
  },

  removeGiftcard: function (state) {
    localStorage.removeItem(STORAGE_GIFTCARD);
    state.giftcard = {
      itWasSend: false,
      isValid: false,
      code: "",
      uuid: "",
      descriptionCode: "",
    };
  },

  removeAllProducts: function (state) {
    localStorage.setItem(STORAGE_PRODUCTS, JSON.stringify([]));
    state.products = [];
  },

  removeAllRemovedProducts: function (state) {
    localStorage.removeItem(STORAGE_REMOVED_PRODUCTS);
    state.removedProducts = [];
  },

  removeAllServices: function (state) {
    localStorage.removeItem(STORAGE_SERVICES);
    state.services = [];
  },

  removeAllLocalStorages: function () {
    localStorage.removeItem(STORAGE_CART_TIMESTAMP);
    localStorage.removeItem(STORAGE_SHOPPING_STEP);
    localStorage.removeItem(STORAGE_SERVICES);
    localStorage.removeItem(STORAGE_CALENDAR);
    localStorage.removeItem(STORAGE_GIFTCARD);
    localStorage.removeItem("filtros_seleccionados");
    localStorage.removeItem("orderFilter");
    localStorage.removeItem(STORAGE_GIFTS);
    localStorage.removeItem(STORAGE_REGALO_RULETA);
    localStorage.removeItem(STORAGE_CARRITO_CODIGO);
  },

  setProductsQuantity: function (state, { product, quantity }) {
    const products = localStorage.getItem(STORAGE_PRODUCTS) ? JSON.parse(localStorage.getItem(STORAGE_PRODUCTS)) : [];
    const existingProductIndex = products.findIndex((item) => item.product.codigo === product.codigo);
    if (existingProductIndex !== -1) {
      products[existingProductIndex].quantity = quantity;
      const totalUnitsInCart = products.reduce((total, item) => total + item.quantity, 0);
      if (totalUnitsInCart <= 3 || products.length === 1) {
        products[existingProductIndex].quantity = products.length == 1 && quantity > 5 ? 5 : quantity;
      } else {
        products.forEach((product) => {
          product.quantity = 2;
        });
      }
    }
    localStorage.setItem(STORAGE_PRODUCTS, JSON.stringify(products));
    state.products = products;
  },

  resetGifts: function (state) {
    localStorage.setItem(STORAGE_GIFTS, JSON.stringify([]));
    state.gifts = [];
  },

  resetRegaloRuleta: function (state) {
    localStorage.setItem(STORAGE_REGALO_RULETA, JSON.stringify([]));
    state.regalo_ruleta = [];
  },

  resetGiftcardInput: function (state) {
    state.giftcardInput = "";
  },
  //#endregion OPERACIONES

  //#region TIMER & VALIDACIONES
  startExpirationTimer: function (state) {
    const config = useRuntimeConfig();
    const expirationMinutes = config.public.timeProductReset;
    mutations.getCartTimestamp(state);
    const expirationTimestamp = state.cartTimestamp + expirationMinutes * 60 * 1000;
    const currentTime = Date.now();
    if (expirationTimer) {
      clearTimeout(expirationTimer);
    }
    if (expirationTimestamp > currentTime) {
      const timeLeft = expirationTimestamp - currentTime;
      expirationTimer = setTimeout(() => {
        mutations.removeAllProducts(state);
        mutations.removeAllLocalStorages();
        expirationTimer = null;
      }, timeLeft);
    } else {
      mutations.removeAllProducts(state);
      mutations.removeAllLocalStorages();
      expirationTimer = null;
    }
  },

  verifyCartTimestamp: function (state) {
    mutations.getProducts(state);
    if (state.products.length > 0) {
      mutations.getCartTimestamp(state);
      const config = useRuntimeConfig();
      const expirationMinutes = config.public.timeProductReset;
      const currentTime = Date.now() - expirationMinutes * 60 * 1000;
      if (currentTime <= state.cartTimestamp) {
        expirationTimer = setTimeout(() => {
          mutations.removeAllProducts(state);
          mutations.removeAllLocalStorages();
          expirationTimer = null;
        }, state.cartTimestamp - currentTime);
      } else {
        mutations.removeAllProducts(state);
        mutations.removeAllLocalStorages();
        expirationTimer = null;
      }
    }
  },

  giftcardLoader: function (state) {
    state.isGiftcardInfoLoading = !state.isGiftcardInfoLoading;
  },
  //#endregion TIMER & VALIDACIONES
};
//#endregion mutations

//#region getters
const getters = {};
//#endregion getters

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions: {},
};
